// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cards-container[data-v-6435d170]{align-items:center;gap:30px;justify-content:space-between}.cards-container[data-v-6435d170],.row-container[data-v-6435d170]{display:flex;flex-wrap:wrap}.col-container[data-v-6435d170]{align-items:center;display:flex;flex-direction:column;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
